import * as React from 'react';

import {motion} from 'framer-motion';

import {colors} from '../colors/colors';

import {sourceTransition, destinationTransition} from './constants';

import styles from './empty-circle.module.css';

type Props = {
    offsetTop: number;
    onClick: () => void;
    forceRemoveIconVisible?: boolean;
};

type State = {
    isHovered: boolean;
};

const motionVariants = {
    init: {
        scale: 1,
        fill: '#fff',
        transition: sourceTransition,
    },
    hover: {
        scale: 1.5,
        fill: colors.rose,
        transition: destinationTransition,
    },
} as const;

export class RemovableEmptyCircle extends React.PureComponent<Props, State> {
    static defaultProps = {
        offsetTop: 9,
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            isHovered: Boolean(props.forceRemoveIconVisible),
        };
    }

    render() {
        return (
            <div
                style={{marginTop: this.props.offsetTop}}
                onMouseEnter={this.hover}
                onMouseLeave={this.unhover}
                onClick={this.props.onClick}
                className={styles['removable-empty-circle']}
            >
                <svg viewBox='0 0 16 16'>
                    <motion.g
                        fill='#fff'
                        variants={motionVariants}
                        animate={this.state.isHovered ? 'hover' : 'init'}
                        whileHover={{scale: 1.5, fill: colors.rose}}
                    >
                        <circle cx='8' cy='8' r='4' />
                        <path
                            stroke='#fff'
                            d='M7.5 5.5 h1 v2 h2 v1 h-2 v2 h-1 v-2 h-2 v-1 h2 z'
                            transform='translate(8, 0.5) scale(0.667) rotate(45)'
                        />
                    </motion.g>
                </svg>
            </div>
        );
    }

    hover = () => {
        this.setState({
            isHovered: true,
        });
    };

    unhover = () => {
        if (!this.props.forceRemoveIconVisible) {
            this.setState({
                isHovered: false,
            });
        }
    };
}
